import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "components/DefaultNavbar/index";
import MyTools from "components/MyTools";
import routes from "routes";
import bgImage from "assets/images/banner.jpg";
import React, { useState, useEffect } from "react";

function Links() {
  const [employeeName, setEmployeeName] = useState(""); // Initialize state for employeeName

  useEffect(() => {
    // Retrieve data from localStorage
    const datosRecuperados = localStorage.getItem("sesion");

    // Check if there is data stored
    if (datosRecuperados) {
      // Convert JSON string to a JavaScript object
      const datos = JSON.parse(datosRecuperados);

      // Access the desired property and update the state
      setEmployeeName(datos.employeeName || ""); // Use an empty string as a default value
    } else {
      console.log("No session data found in localStorage.");
    }
  }, []); // Empty array indicates that this effect runs only once, when the component mounts
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "",
          label: employeeName,
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="20vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      ></MKBox>
      <Card
        sx={{
          p: 4,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
            rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MyTools />
      </Card>
    </>
  );
}

export default Links;
